export const GET_DEALER_API_REQUEST = "GET_DEALER_API_REQUEST";
export const GET_DEALER_API_SUCCESS = "GET_DEALER_API_SUCCESS";
export const GET_DEALER_API_ERROR = "GET_DEALER_API_ERROR";

export const DEALERS_LOAD_MORE = "DEALERS_LOAD_MORE"
export const EDIT_DEALER_SEARCH_QUERY = "EDIT_DEALER_SEARCH_QUERY"
export const EDIT_SELECTED_DEALER = "EDIT_SELECTED_DEALER"

export const GET_DEALER_BY_ID_API_REQUEST = "GET_DEALER_BY_ID_API_REQUEST";
export const GET_DEALER_BY_ID_API_SUCCESS = "GET_DEALER_BY_ID_API_SUCCESS";
export const GET_DEALER_BY_ID_API_ERROR = "GET_DEALER_BY_ID_API_ERROR";

export const GET_DEALER_COLLECTIONS = "GET_DEALER_COLLECTIONS";
export const GET_DEALER_ASSETS = "GET_DEALER_ASSETS";
export const GET_DEALER_ASSETS_NAMES = "GET_DEALER_ASSETS_NAMES";
export const SET_DEALER_COLLECTIONS = "SET_DEALER_COLLECTIONS";
export const SET_DEALER_ASSETS = "SER_DEALER_ASSETS";
export const SET_DEALER_ASSETS_NAMES= "SET_DEALER_ASSETS_NAMES";

export const DEFAULT_PAGE_SIZE = 15;

export const GET_EXTDEALER_BY_ID_API_REQUEST = "GET_EXTDEALER_BY_ID_API_REQUEST";